import type { Tile } from '../hex/types';

export type MapModel = {
    tiles: Tile[];
    tileMap: Map<string, Tile>;
    getTileByCube: (q: number, r: number, s: number) => Tile | null;
    getTilesInRadius: (q: number, r: number, s: number, radius: number) => Tile[];
};

export function createMapModel(tiles: Tile[]): MapModel {
    const tileMap = new Map<string, Tile>();
    tiles.forEach((tile) => {
        const { q, r, s } = tile.position;
        tileMap.set(`${q},${r},${s}`, tile);
    });

    return {
        tiles,
        tileMap,
        getTileByCube(q: number, r: number, s: number) {
            return tileMap.get(`${q},${r},${s}`) || null;
        },
        getTilesInRadius(q: number, r: number, s: number, radius: number) {
            const results: Tile[] = [];
            for (let dq = -radius; dq <= radius; dq += 1) {
                for (
                    let dr = Math.max(-radius, -dq - radius);
                    dr <= Math.min(radius, -dq + radius);
                    dr += 1
                ) {
                    const nq = q + dq;
                    const nr = r + dr;
                    const ns = -nq - nr;
                    const tile = tileMap.get(`${nq},${nr},${ns}`);
                    if (tile) results.push(tile);
                }
            }
            return results;
        },
    };
}
